import { render } from "./GroupCheckbox.vue?vue&type=template&id=518dd838"
import script from "./GroupCheckbox.vue?vue&type=script&lang=js"
export * from "./GroupCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__